module.exports = __webpack_public_path__ + "img/changjiang.fa7f1502.png";